exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-image: url(\"/assets/pictures/login-bg.jpg\");\n  background-position: 51.25% center;\n  background-repeat: no-repeat;\n  background-color: transparent;\n  background-size: cover;\n  overflow: hidden; }\n\n.logo {\n  color: #242831;\n  margin-bottom: 20px;\n  font-size: 36px; }\n\nbutton {\n  width: 220px;\n  height: 36px;\n  border: none;\n  border-radius: 2px;\n  color: #FFF;\n  font-family: 'Roboto', sans-serif;\n  font-weight: 500;\n  transition: 0.2s ease;\n  cursor: pointer; }\n\n.facebook-login {\n  background: #32508E; }\n  .facebook-login:hover {\n    background: rgba(50, 80, 142, 0.9); }\n\n.button-wrapper {\n  background: rgba(255, 255, 255, 0.95);\n  position: absolute;\n  top: 83%;\n  left: 50%;\n  min-width: 377px;\n  box-sizing: border-box;\n  text-align: center;\n  padding: 25px 50px;\n  box-shadow: 0 0 80px -10px rgba(0, 0, 0, 0.65);\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  border-radius: 4px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Development/Private Projects/random-ride/RandomRide/src/app/login-page/login.page.scss
// module id = ../../../../../src/app/login-page/login.page.scss
// module chunks = main